import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { fireErrorAnalyticsEvents } from '@atlassian/jira-servicedesk-knowledge-common/src/common/utils';
import { listCategories } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/categories/index.tsx';
import { FETCH_CATEGORIES } from '../../state/actions/fetch-categories';
import { fetchCategoriesFailure } from '../../state/actions/fetch-categories-failure';
import { fetchCategoriesSuccess } from '../../state/actions/fetch-categories-success';
import { getActivationId, getProjectId } from '../../state/selectors/base';
import type { State } from '../../state/types';
import { PACKAGE_NAME } from '../../view/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(FETCH_CATEGORIES).mergeMap((action) => {
		const projectId = getProjectId(store.getState());
		const { analyticsEvent } = action.payload;
		const activationId = getActivationId(store.getState());
		return listCategories(projectId, activationId)
			.mergeMap((categories) => {
				fireTrackAnalytics(analyticsEvent, 'onFetchCategories success', {
					projectId,
				});
				return Observable.of(fetchCategoriesSuccess(categories));
			})
			.catch((error) => {
				fireErrorAnalyticsEvents(error, 'onFetchCategoriesFailure', PACKAGE_NAME);
				return Observable.of(fetchCategoriesFailure(error));
			});
	});
